import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useModalCreateFolder} from 'interface/hooks/useModalCreateFolder';
import {useModalTrash} from 'interface/hooks/useModalTrash';
import {useModalPurge} from 'interface/hooks/useModalPurge';
import {selectors} from 'store/slices/files';
import events from 'extensions/events';

import * as effectsFiles from 'interface/hooks/effects/files';
import * as effectsTransfers from 'interface/hooks/effects/transfers';

export function useHotkeys(folderKey: string) {
  const isSearch = useSelector(selectors.isSearch);
  const selection = useSelector(selectors.getSelection);
  const modalTrash = useModalTrash(selection);
  const modalPurge = useModalPurge(selection);
  const modalCreateFolder = useModalCreateFolder(folderKey);

  const dispatch = useDispatch();

  useEffect(() => events.addKeyListener('up', (e) => {
    switch (e.code) {
      // Exit search
      case 'Escape':
        break;
        if (isSearch)
          effectsFiles.search(dispatch, null, folderKey)();
        break;
      // Open uploader
      case 'KeyU':
        break;
        if (isSearch) break;
        effectsTransfers.uploadStart(dispatch, folderKey)();
        break;
      // Create folder
      case 'KeyN':
        break;
        if (isSearch) break;
        modalCreateFolder.open();
        break;
      // Open delete prompt
      case 'Delete':
      case 'Backspace':
        break;
        if (selection.length > 0 && (e.code !== 'Backspace' || e.flags.shiftKey)) {
          if (folderKey === 'trash') {
            modalPurge.open();
          } else {
            modalTrash.open();
          }
        }
        break;
    }
  }).unsubscribe, [folderKey, selection, isSearch]);
}
